import * as Yup from 'yup';

const requiredMessage = `This field is required`;

export const referenceFormValidationSchema = () => {
  const fields: any = {
    publication_id: Yup.string().trim().required(requiredMessage).nullable(),
    type: Yup.string().nullable(),
    variant_included: Yup.boolean().nullable(),
    include_in_report: Yup.boolean().nullable(),
  };

  return Yup.object().shape(fields);
};
